import React from 'react'
import './index.scss'
import SessionTitle from '../SectionTitle'
import PointItem from '../PointItem'

const Features = ({folder}) => {
  return (
    <div className='features-jibunehon'>
      <SessionTitle
        title="POINT"
        subtitle="JibunEhonの特徴"
        background="#FFAF00"
        color="#782D00"
      />
      
      <PointItem
        title="お子さんが主人公"
        subtitle="主人公の名前と容姿をカスタマイズ"
        imageUrl={`https://shueisya-prd-s3.s3.ap-northeast-1.amazonaws.com/features/${folder}/Features1.webp`}
        number={1}
      />

      <PointItem
        title="写真とオリジナルメッセージ"
        subtitle="お子さんの写真と心を込めた"
        subtitle_2="メッセージを挿入"
        imageUrl={`https://shueisya-prd-s3.s3.ap-northeast-1.amazonaws.com/features/${folder}/Features2.webp`}
        number={2}
      />
    
      <PointItem
        title="プロのイラストレーター<br/>描きおろし"
        subtitle="日本の昔話を可愛くてPOPなイラストで"
        imageUrl={`https://shueisya-prd-s3.s3.ap-northeast-1.amazonaws.com/features/${folder}/Features3.webp`}
        number={3}
      />

      <PointItem
        title="高精細なRGB印刷"
        subtitle="子供達の目を惹きつける鮮やかな色彩"
        videoUrl={`https://shueisya-prd-s3.s3.ap-northeast-1.amazonaws.com/features/${folder}/Features4.mp4`}
        number={4}
      />

      <PointItem
        title="耐水で破れにくい紙"
        subtitle="合成紙ユポを使用しているので耐水で"
        subtitle_2="破れにくい有害物質を使用していない"
        subtitle_3="ので噛んでも安全"
        imageUrl={`https://shueisya-prd-s3.s3.ap-northeast-1.amazonaws.com/features/${folder}/Features5.webp`}
        number={5}
      />
    
      <PointItem
        title="専用ギフトケース"
        subtitle="シックで上質な専用ギフトケースで"
        subtitle_2="お届け"
        imageUrl={`https://shueisya-prd-s3.s3.ap-northeast-1.amazonaws.com/features/${folder}/Gift-Case6.webp`}
        number={6}
      />
    </div>
  )
}

export default Features
